export var BiFormSubmissionStatus;
(function (BiFormSubmissionStatus) {
    BiFormSubmissionStatus["INIT"] = "INITIATE_SUBMISSION";
    BiFormSubmissionStatus["VALIDATION_FAILURE"] = "VALIDATION_FAILURE";
    BiFormSubmissionStatus["FAILURE"] = "FAILURE";
    BiFormSubmissionStatus["SUCCESS"] = "SUCCESS";
})(BiFormSubmissionStatus || (BiFormSubmissionStatus = {}));
//# sourceMappingURL=bi.js.map